import { inventoreeBoardQuery } from '../api/inventoreeBoard'
import { ModuleBoardPage } from '../dashboard/ModuleBoardPage'

/**
 * Tabloul de bord Inventoree - adresa `inventoree/dashboard`, care in
 * CodeIgniter ajunge la `Dashboard::module('inventoree')`.
 *
 * NU e `inventoree/DashboardPage.tsx` de alaturi: acela e tabloul AmCharts
 * VECHI, lasat de Bogdan pe 6 septembrie 2026, care nu are ruta si nu
 * primeste una. Asta e tabloul de MODUL, cel pe care il vede omul azi cand
 * apasa "Dashboard" in bara Inventoree.
 *
 * Pagina insasi e `ModuleBoardPage`, comuna cu Easeedesk.
 */
export function InventoreeDashboardPage() {
  return <ModuleBoardPage query={inventoreeBoardQuery} basePath="/app/inventoree/dashboard" />
}
